module.exports = __webpack_public_path__ + "static/img/login_bg.3cd036a7.jpg";